import { createApp } from 'vue'
import App from './App.vue'
import messages from './i18n'

const i18n = window.VueI18n.createI18n({
    locale: window.config.getLang(),
    fallbackLocale: 'cz',
    messages,
})

export const mount = (): void => {
    const app = createApp(App)
    app.use(i18n)
    app.mount('#vue-invitation')
}
